import { render, staticRenderFns } from "./ViewEmployee.vue?vue&type=template&id=521601fa&scoped=true"
import script from "./ViewEmployee.vue?vue&type=script&lang=js"
export * from "./ViewEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521601fa",
  null
  
)

export default component.exports